import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CoreModule } from 'app/modules/core/core.module';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';

@NgModule({
    declarations: [
        LanguagesComponent
    ],
    imports     : [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        CoreModule
    ],
    exports     : [
        LanguagesComponent
    ]
})
export class LanguagesModule
{
}
